type VariableDefinition = { name: string; value: string; [key: string]: any };

const getVariablesFromString = (value: string): string[] => {
  const matches = value.match(/{{(.*?)}}/g);

  if (matches) {
    return matches.map(match => match.replace(/({{|}})/g, ''));
  }

  return [];
};

const addVariableToString = (
  string: string,
  variable: VariableDefinition,
): string => {
  if (string && variable.value) {
    const textToReplace = RegExp(`{{${variable.name}}}`, 'g');
    return string.replace(textToReplace, variable.value);
  }

  return string;
};

const VariableHelpers = {
  getVariablesFromString,
  addVariableToString,
};

export default VariableHelpers;
